import { render, staticRenderFns } from "./TotalShare.vue?vue&type=template&id=74352b10&scoped=true&"
import script from "./TotalShare.vue?vue&type=script&lang=js&"
export * from "./TotalShare.vue?vue&type=script&lang=js&"
import style0 from "./TotalShare.vue?vue&type=style&index=0&id=74352b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74352b10",
  null
  
)

export default component.exports